import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';

import {
  authenticatedAPICall,
  isSuccessfulAPIResponse,
} from '../../client/api-client';
import { ListUser } from '../../types/types';
import { repeat } from 'lit/directives/repeat.js';
import '../../elements/langhout-button/langhout-button';
import '../langhout-beton-update-template/langhout-beton-update-template';
import { sharedStyles } from '../../elements/shared-styles';

@customElement('langhout-beton-list-users')
export class LanghoutBetonListUsers extends LitElement {
  static styles = [
    sharedStyles,
    css`
      .row {
        display: flex;
        flex-direction: row;
      }

      .product-column {
        text-align: left;
        width: 100%;
        min-width: 120px;
        min-height: calc(54px - 24px);
      }

      .border-bot {
        border-bottom: 2px solid var(--menu-color);
      }

      .table-wrapper {
        overflow-x: auto;
      }

      .table-header {
        color: var(--text-color-light);
      }

      .header-column {
        background-color: var(--menu-color);
        padding-left: 12px;
      }

      .column-border-right {
        border-right: 2px solid var(--menu-color);
      }
    `,
  ];

  private requestCounter = 0;

  private listTimer = 0;

  @property({ type: Array })
  private users: ListUser[] = [];

  constructor() {
    super();
    this.listUsers();
  }

  render() {
    return html`
      <div class="table-wrapper">
        <div class="row table-header">
          <div class="column header-column product-column">
            <div class="row">
              <h3>Naam</h3>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Email</h3>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Rollen</h3>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Geblokkeerd</h3>
            </div>
          </div>
        </div>
        ${this.renderRows()}
      </div>
    `;
  }

  renderRows = () => {
    return html` ${repeat(
      this.users,
      (user: ListUser) => user.id,
      (user: ListUser, index: number) => {
        let tableColumnClass = 'border-bot';
        if (index == this.users.length - 1) {
          tableColumnClass = '';
        }
        return html`
          <div
            class="row table-row"
            @click="${() => {
              window.location.href = `/edit-user?id=${user.id}`;
            }}"
          >
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${user.first_name} ${user.last_name}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${user.email}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${user.roles.join(' , ')}
            </div>
            <div class="column table-column product-column ${tableColumnClass}">
              ${user.blocked ? 'Ja' : 'Nee'}
            </div>
          </div>
        `;
      },
    )}`;
  };

  listWithBackoff = () => {
    clearInterval(this.listTimer);
    this.listTimer = window.setTimeout(() => {
      this.listUsers();
    }, 50);
  };

  listUsers = async () => {
    this.requestCounter++;
    const requestCounter = this.requestCounter;

    const path = `/users`;

    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (requestCounter != this.requestCounter) {
      return;
    }
    if (isSuccessfulAPIResponse(result)) {
      this.users = result.body;
    }
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-list-users': LanghoutBetonListUsers;
  }
}
